<template>
	<div class="page">
		<div class="title" style="color: #333;">{{obj.title}}</div>
		<p class="date">{{obj.date}}</p>
		<div v-html="obj.content"></div>
	</div>
</template>

<script>
	import _news_data from './news.js'

	export default {
	   name: '',
	   data() {
			return {
				obj: {
					title: '',
					date: '',
					content: '',
				},
			}
		},
		methods: {
			replaceAssetsPath(content) {
				if (!content) return content
				// 静态 require 映射表：@/assets/news/xx/xx → webpack 打包后的 URL
				const localImgs = {
					'news/01/01.png': require('../assets/news/01/01.png'),
					'news/01/02.png': require('../assets/news/01/02.png'),
					'news/01/03.png': require('../assets/news/01/03.png'),
					'news/01/04.png': require('../assets/news/01/04.png'),
					'news/01/05.png': require('../assets/news/01/05.png'),
					'news/01/06.png': require('../assets/news/01/06.png'),
					'news/01/07.png': require('../assets/news/01/07.png'),
					'news/01/08.jpg': require('../assets/news/01/08.jpg'),
					'news/01/09.jpg': require('../assets/news/01/09.jpg'),
					'news/02/01.jpg': require('../assets/news/02/01.jpg'),
					'news/02/02.jpg': require('../assets/news/02/02.jpg'),
					'news/02/03.jpg': require('../assets/news/02/03.jpg'),
					'news/02/04.jpg': require('../assets/news/02/04.jpg'),
					'news/03/01.png': require('../assets/news/03/01.png'),
					'news/03/02.png': require('../assets/news/03/02.png'),
					'news/04/01.jpg': require('../assets/news/04/01.jpg'),
					'news/04/02.jpg': require('../assets/news/04/02.jpg'),
					'news/04/03.jpg': require('../assets/news/04/03.jpg'),
					'news/04/04.png': require('../assets/news/04/04.png'),
					'news/04/05.png': require('../assets/news/04/05.png'),
					'news/04/06.png': require('../assets/news/04/06.png'),
					'news/04/07.png': require('../assets/news/04/07.png'),
					'news/04/08.png': require('../assets/news/04/08.png'),
					'news/05/01.jpg': require('../assets/news/05/01.jpg'),
					'news/05/02.jpg': require('../assets/news/05/02.jpg'),
					'news/05/03.jpg': require('../assets/news/05/03.jpg'),
					'news/05/04.jpg': require('../assets/news/05/04.jpg'),
					'news/06/01.png': require('../assets/news/06/01.png'),
					'news/06/02.jpg': require('../assets/news/06/02.jpg'),
					'news/06/03.jpg': require('../assets/news/06/03.jpg'),
					'news/06/04.png': require('../assets/news/06/04.png'),
					'news/06/05.jpg': require('../assets/news/06/05.jpg'),
					'news/07/01.png': require('../assets/news/07/01.png'),
					'news/07/02.png': require('../assets/news/07/02.png'),
					'news/07/03.png': require('../assets/news/07/03.png'),
					'news/08/01.png': require('../assets/news/08/01.png'),
					'news/other/01.png': require('../assets/news/other/01.png'),
					'news/other/02.png': require('../assets/news/other/02.png'),
					'news/other/03.png': require('../assets/news/other/03.png'),
					'news/other/04.png': require('../assets/news/other/04.png'),
					'news/other/05.png': require('../assets/news/other/05.png'),
					'news/other/06.png': require('../assets/news/other/06.png'),
					'news/other/07.png': require('../assets/news/other/07.png'),
				}
				return content.replace(/@\/assets\/([\w/.-]+\.\w+)/g, (m, p1) => {
					return localImgs[p1] || m
				})
			}
		},
		mounted() {
			
			// let parentid = this.$route.query.id
			// let url =
			//   this.HOST + 'wzContent/info?id=' + parentid
			// this.$axios.get(url).then((res) => {
			// 	this.obj = res.data.content
			// })
			let newsId = this.$route.query.id
			// 从_news_data中找到id为newsId的新闻
			// 并将该新闻的title、date、content赋值给this.obj
			let news = _news_data.find(item => item.id == newsId)
			this.obj.date = news.date
			this.obj.title = news.title
			// 将content中的@/assets/路径替换为webpack打包后的真实URL
			this.obj.content = this.replaceAssetsPath(news.content)
		}
	}
</script>

<style lang="less" scoped>
	.page{
		width: 1000px;
		margin: 30px auto;
		text-align: left;

		.title {
			font-size: 24px;
			font-weight: 700;
			margin-bottom: 20px;
		}

		.date {
			margin-bottom: 20px;
			color: #999;
		}
	}
</style>